import { QueryState } from "src/app/core/models/query.model";
import { createTokenQueryServiceInstance } from "src/app/core/services/query-sentrynel.service";
import { SignalStoreConfig } from "src/app/shared/functions/store.functions";

export const DANGEROUS_EVENT_ENDPOINT = 'catalog-dangerous-event';
export const DANGEROUS_EVENT_QUERY_SERVICE_INSTANCE = createTokenQueryServiceInstance(DANGEROUS_EVENT_ENDPOINT);

export const dangerousEventStateConfig: SignalStoreConfig<QueryState<any>> = {
  initState: {
    list: []
  }
}

export const LISTA_DANGEROUS_EVENT_COLUMNS: any[] = [
  {
    name: 'id',
    label: 'Id',
    field: 'id',
    primaryKey: true,
    type:'text'
  },
  {
    name: 'code',
    label: 'Codice',
    field: 'code',
    type:'text'
  },
  {
    name: 'name',
    label: 'Nome',
    field: 'name',
    type:'text'
  },
  {
    name: 'description',
    label: 'Descrizione',
    field: 'description',
    type:'text'
  },
  {
    name: 'eventType',
    label: 'Tipologia',
    field: 'eventType',
    type:'text'
  },
  {
    name: 'scopeType',
    label: 'Ambito',
    field: 'scopeType',
    type:'text'
  },
  {
    name: 'isActive',
    label: 'Attivo',
    field: 'isActive',
    type:'active'
  }
];

export const LISTA_DANGEROUS_EVENT_VISIBLE_COLUMNS = [
  'select',
  'code',
  'name',
  'description',
  'eventType',
  'isActive',
  'azioni',
];

export enum DangerousEventTypeEnum {
  BIOLOGICAL = 'BIOLOGICAL',
  CHEMICAL = 'CHEMICAL',
  PHYSICAL_ACCEPTABILITY = 'PHYSICAL-ACCEPTABILITY',
  PHYSICAL_QUANTITATIVE = 'PHYSICAL-QUANTITATIVE'
}

export enum DangerousEventScopeTypeEnum {
  CATALOG = 'CATALOG',
  CUSTOM = 'CUSTOM'
}

export const DANGEROUS_EVENT_TYPE =[
  {key: "BIOLOGICAL", value :"Biologico" },
  {key: "CHEMICAL", value :"Chimico"},
  {key: "PHYSICAL-ACCEPTABILITY", value :"Fisico-Accettabilità"},
  {key: "PHYSICAL-QUANTITATIVE", value :"Fisico-Quantitativo"}
]
